export default __webpack_public_path__ + "static/media/ITRealCase2-en.84a305f0.jpg";